<h1 mat-dialog-title><span class="title">{{data.title}}</span> <mat-icon (click)="closeDialog()">close</mat-icon></h1>
<div class="info-content" mat-dialog-content [innerHTML]="data.description"></div>
